/**
 * Anemoia shop category menu (custom).
 *
 * SHOP in the desktop nav is a toggle, not a link: hover already drops the
 * ALL / JACKET / JERSEY panel (pure CSS), and this makes a click or Enter/Space
 * do the same, so it also works for a keyboard or a touch screen at desktop
 * width. A click anywhere else, or Escape, puts it away.
 *
 * In the mobile menu SHOP is a row with a + beside it; a tap slides in SHOP's
 * own panel in place of the main list, and ← Menu slides back. Closing the
 * menu resets it, so it always reopens on the main list.
 */

const OPEN_CLASS = 'is-anemoia-shop-open';

const openItems = () => document.querySelectorAll(`.${OPEN_CLASS}`);

function setOpen(item, open) {
  item.classList.toggle(OPEN_CLASS, open);
  item.querySelector('[data-anemoia-shop-toggle]')?.setAttribute('aria-expanded', String(open));
}

function closeAll(except) {
  openItems().forEach((item) => {
    if (item !== except) setOpen(item, false);
  });
}

function toggleFrom(toggle) {
  const item = toggle.closest('.menu-list__list-item');
  if (!item) return;
  closeAll(item);
  setOpen(item, !item.classList.contains(OPEN_CLASS));
}

// Focus only follows a keyboard activation (click detail 0); moving it on a tap
// would draw a focus box on a touch screen.
function setDrawerSub(row, open, { focus = true } = {}) {
  if (!row) return;
  const drawer = row.closest('.menu-drawer');
  const toggle = row.querySelector('[data-anemoia-shop-drawer-toggle]');
  row.classList.toggle('is-open', open);
  toggle?.setAttribute('aria-expanded', String(open));
  drawer?.classList.toggle('is-anemoia-shop-sub', open);

  if (open) {
    drawer?.classList.remove('is-anemoia-shop-back');
    if (focus) row.querySelector('[data-anemoia-shop-drawer-back]')?.focus({ preventScroll: true });
    return;
  }
  // Stays on until the menu closes: dropping it mid-way would restart the rows'
  // own staggered entrance.
  drawer?.classList.add('is-anemoia-shop-back');
  if (focus) toggle?.focus({ preventScroll: true });
}

// When the menu closes, put SHOP's panel away so it reopens on the main list.
document.addEventListener(
  'toggle',
  (event) => {
    if (!(event.target instanceof HTMLDetailsElement) || event.target.open) return;
    event.target.querySelectorAll('.anemoia-shop-menu--drawer.is-open').forEach((row) => {
      setDrawerSub(row, false, { focus: false });
    });
    event.target.querySelectorAll('.is-anemoia-shop-back').forEach((drawer) => {
      drawer.classList.remove('is-anemoia-shop-back');
    });
  },
  true
);

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const drawerToggle = event.target.closest('[data-anemoia-shop-drawer-toggle]');
  if (drawerToggle) {
    setDrawerSub(drawerToggle.closest('.anemoia-shop-menu--drawer'), true, { focus: event.detail === 0 });
    return;
  }
  const drawerBack = event.target.closest('[data-anemoia-shop-drawer-back]');
  if (drawerBack) {
    setDrawerSub(drawerBack.closest('.anemoia-shop-menu--drawer'), false, { focus: event.detail === 0 });
    return;
  }
  const toggle = event.target.closest('[data-anemoia-shop-toggle]');
  if (toggle) {
    event.preventDefault();
    toggleFrom(toggle);
    return;
  }
  const insideOpen = event.target.closest(`.${OPEN_CLASS}`);
  if (!insideOpen) closeAll();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeAll();
    return;
  }
  if (event.key !== 'Enter' && event.key !== ' ') return;
  if (!(event.target instanceof Element) || !event.target.matches('[data-anemoia-shop-toggle]')) return;
  event.preventDefault();
  toggleFrom(event.target);
});
